import { FC, useState, useEffect, useCallback } from 'react'

import { Tab } from 'components'
import { useLocation } from 'react-router-dom'

import CreSearch from './components/CreSearch/CreSearch'
import GenerateCre from './components/GenerateCre/GenerateCre'
import ManageCre from './components/ManageCre/ManageCre'

const Cre: FC = () => {
  const location = useLocation<any>()
  const [tabs, setTabs] = useState(['Pesquisar', 'Gerar Carteira', 'Gerenciar Carteira'])
  const [selectedTab, setSelectedTab] = useState(0)
  const handleChange = (_, newValue) => setSelectedTab(newValue)


  const handleComeBack = useCallback(() => {
    if (location?.state?.tab) {
      setSelectedTab(location?.state?.tab)
    }
  }, [location])

  useEffect(() => {
    handleComeBack()
  }, [handleComeBack])

  return (
    <>
      <Tab tabs={tabs} value={selectedTab} handleChange={handleChange} />
      {selectedTab === 0 && <CreSearch />}
      {selectedTab === 1 && <GenerateCre />}
      {selectedTab === 2 && <ManageCre />}
    </>
  )
}

export default Cre
